import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Modal.css';

const ModalContent = ({
  className,
  children,
  ...otherProps
}) => {
  const classes = classNames(
    'content',
    'ng-ui-modal-content',
    className
  );

  return (
    <div
      className={classes}
      {...otherProps}
    >
      {children}
    </div>
  );
};

ModalContent.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

ModalContent.displayName = 'Modal.Content';

export default ModalContent;